import { talentApi } from 'yxt-biz-pc/packages/api';

export default {
  /**
   * 获取测训列表
   * @param data
   * @returns {*}
   */
  getTrainingList(data, config) {
    return talentApi.post('mgr/training/all/page', data, config);
  },
  /**
   * 获取测训分类
   * @param data
   * @returns {*}
   */
  getTrainingCategory(data) {
    return talentApi.get('mgr/category/1/list', data);
  }
};
